module.exports = __webpack_public_path__ + "images/tips/info-image-03@2x.8397667fb178f90df99a.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/tips/info-image-03@2x.png
// module id = zeUJ
// module chunks = 13